import { render } from "./networkDetector.vue?vue&type=template&id=58864a0d&scoped=true"
import script from "./networkDetector.vue?vue&type=script&lang=js"
export * from "./networkDetector.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=58864a0d&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58864a0d"]])

export default __exports__